<form novalidate class="login" [formGroup]="loginForm">
  <div *ngIf="loginStep === 'email'" [@slideInRight]>
    <auth-email-step
      [loginForm]="loginForm"
      [isLoading]="isLoading"
      [loginCustomization]="loginCustomization"
      (toPasswordStep)="toPasswordStep()"
    ></auth-email-step>
  </div>

  <div *ngIf="loginStep === 'password'" [@slideInRight]>
    <auth-password-step
      [loginForm]="loginForm"
      [isLoading]="isLoading"
      [lookupResult]="lookupResult"
      [loginCustomization]="loginCustomization"
      (authenticate)="auth()"
      (authWithAd)="authWithAd()"
      (authWithGoogle)="authWithGoogle()"
      (returnToEmailStep)="loginStep = 'email'; loginForm.reset()"
    ></auth-password-step>
  </div>

  <div *ngIf="loginStep === 'softwareToken'" [@slideInRight]>
    <mfa-step
      [isLoading]="isLoading"
      [verificationCodeForm]="verificationCodeForm"
      (insertVerificationCode)="authWithSoftwareToken()"
      (toRecoveryCodeStep)="toRecoveryCodeStep()"
    ></mfa-step>
  </div>

  <div *ngIf="loginStep === 'recoveryCode'" [@slideInRight]>
    <recovery-code-step
      [isLoading]="isLoading"
      [recoveryCodeInput]="recoveryCodeInput"
      (insertRecoveryCode)="authWithRecoveryCode()"
      (toSoftwareTokenStep)="toSoftwareTokenStep()"
    ></recovery-code-step>
  </div>

  <div *ngIf="loginStep === 'resetPassword' || loginStep === 'expiredPassword'" [@slideInRight]>
    <new-password-step
      [title]="'LOGIN.AUTH.RESET_TITLE'"
      [description]="'LOGIN.AUTH.RESET_DESCRIPTION'"
      [isLoading]="isLoading"
      [resetPasswordForm]="resetPasswordForm"
      [disabled]="isLoading || resetPasswordForm.invalid"
      (resetPassword)="loginStep === 'resetPassword' ? createNewPassword() : createNewPasswordAfterExpiredAndLogin()"
    ></new-password-step>
  </div>

  <div *ngIf="loginStep === 'successOnResetPassword'" [@slideInRight]>
    <success-step (backToLogin)="onClickBackToLogin()"></success-step>
  </div>

  <div *ngIf="loginStep === 'expiredSoonPassword'" [@slideInRight]>
    <expiring-password-step
      [isLoading]="isLoading"
      [extraAuthInfo]="extraAuthInfo"
      (resetPassword)="toNewPasswordStep(true)"
      (authWithoutResetPassword)="authWithExpiringPassword()"
    ></expiring-password-step>
  </div>
</form>
